import React from 'react'
import { Stack, StackProps } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { ClassesType } from '../../types'
import Text from '../Text'

const useStyles = makeStyles(
  theme => ({
    root: {
      cursor: 'pointer',
    },
    iconContainer: {
      width: 20,
      height: 20,
      borderRadius: 10,
      backgroundColor: theme.colors.lowAccentText,
    },
    icon: {
      color: theme.colors.tableBackground,
      width: 16,
      height: 16,
    },
    label: {},
  }),
  { name: 'IconLabelButton' },
)

export interface IconLabelButtonProps extends StackProps {
  readonly Icon: React.JSXElementConstructor<any>
  readonly classes?: ClassesType<typeof useStyles>
  readonly label?: React.ReactNode
}

const IconLabelButton = ({
  Icon,
  label,
  classes: classesProp,
  ...rest
}: IconLabelButtonProps) => {
  const classes = useStyles({ classes: classesProp })

  return (
    <Stack className={classes.root} direction="row" {...rest}>
      <Stack
        alignItems="center"
        className={classes.iconContainer}
        justifyContent="center"
        mr={0.5}
      >
        <Icon className={classes.icon} />
      </Stack>
      <Text className={classes.label} variant="lowAccent2">
        {label}
      </Text>
    </Stack>
  )
}

export default IconLabelButton
